import React from 'react';
import { Waves, Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center">
                <Waves className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Move to Cornwall</h3>
                <p className="text-xs text-slate-400">Ontario's Hidden Gem</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed">
              Discover the perfect blend of natural beauty, affordability, and opportunity on the shores of the St. Lawrence River.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Explore</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm hover:text-emerald-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('benefits')}
                  className="text-sm hover:text-emerald-400 transition-colors"
                >
                  Why Cornwall
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('blog')}
                  className="text-sm hover:text-emerald-400 transition-colors"
                >
                  Resources & Blog
                </button>
              </li>
              <li>
                <Link to="/advertising" className="text-sm hover:text-emerald-400 transition-colors">
                  Advertise With Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-emerald-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-bold mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/trail-maps" className="text-sm hover:text-emerald-400 transition-colors">
                  Trail Maps
                </Link>
              </li>
              <li>
                <Link to="/housing-market" className="text-sm hover:text-emerald-400 transition-colors">
                  Housing Market Data
                </Link>
              </li>
              <li>
                <Link to="/business-resources" className="text-sm hover:text-emerald-400 transition-colors">
                  Business Resources
                </Link>
              </li>
              <li>
                <Link to="/community-guide" className="text-sm hover:text-emerald-400 transition-colors">
                  Community Guide
                </Link>
              </li>
              <li>
                <Link to="/quizzes" className="text-sm hover:text-emerald-400 transition-colors">
                  Cornwall Quizzes
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-4">Get in Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-emerald-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-white">Email</p>
                  <a href="mailto:info@movetocornwall.ca" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">
                    info@movetocornwall.ca
                  </a>
                </div>
              </div>
              <p className="text-sm text-slate-400">
                We respond to all inquiries within 24 hours.
              </p>
              <Link to="/contact">
                <button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-2 rounded-lg transition-colors flex items-center justify-center space-x-2">
                  <span>Contact Us</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-slate-400">
              © {currentYear} Move to Cornwall. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};